import { render, staticRenderFns } from "./imgUploadd.vue?vue&type=template&id=4bc405e6&scoped=true&"
import script from "./imgUploadd.vue?vue&type=script&lang=js&"
export * from "./imgUploadd.vue?vue&type=script&lang=js&"
import style0 from "./imgUploadd.vue?vue&type=style&index=0&id=4bc405e6&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc405e6",
  null
  
)

export default component.exports